import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-item-business-term-loan.component.scss';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
var regYearValid = true;
var regTypeValid = true;
var FormItemBusinessTermLoan = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessTermLoan, _super);
    function FormItemBusinessTermLoan(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.count = 1;
        _this.sbcustomer = '';
        _this.sbPrefSupplier = '';
        _this.dataChecks = true;
        _this.map = new Map();
        _this.iSstep1Completed = false;
        _this.iSstep2Completed = false;
        _this.iSstep3Completed = false;
        _this.isRegMatchingEntity = true;
        _this.isRegYearValid = true;
        return _this;
    }
    FormItemBusinessTermLoan.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.businessType = this.element.querySelector(".js-business-type");
        this.wizardContainer = this.element.querySelector('.form-container-wizard__wizard');
        this.wizardStepsContainer = this.element.querySelector('.form-container-wizard__steps');
        this.bulletContainer = this.element.querySelector('.form-container-wizard__bullets-container');
        this.customHeading = this.element.querySelector('.customHeading');
        this.stepNo = this.element.querySelector('.form-container-wizard__stepno');
        this.sbAccountNumber = this.element.querySelector(".js-sb-account-number");
        this.isSBCustomer = this.element.querySelector(".js-sb-customer-radio-group");
        this.formDatePicker = this.element.querySelector('.js-date-picker');
        this.formTimePicker = this.element.querySelector('.js-time-picker');
        // buttons
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.backButton = Array.from(this.element.querySelectorAll('.js_prev-step-button'));
        this.step1Button = this.element.querySelector('.js_next-step1-button');
        this.step2Button = this.element.querySelector('.js_next-step2-button');
        this.showStep(1);
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-sb-customer-radio-group'));
        this.sbPreferredSupplierToggle = Array.from(this.element.querySelectorAll('.js-sb-pref-supp-radio-group'));
        this.relPubOfficialRadiosToggle = Array.from(this.element.querySelectorAll('.js-sb-rel-pub-official-radio-group'));
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
            this.displayDecline = this.form.querySelector('.form-container__declined');
        }
        this.buttonSubmit = this.element.querySelector('.js_submit-button');
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
        this.relPartiesHideBtn = this.element.querySelector('.data-rel-parties-hide-btn');
        this.relPartiesShowBtn = this.element.querySelector('.data-rel-parties-show-btn');
        this.relPartiesContent = this.element.querySelector('.data-rel-parties-content');
        // Analytics
        this.analyticsService.startDtmApplication("application: borrow for your needs | business term loan", "business term loan");
        this.updatePageName('step 1 personal details');
        // calender
        this.publicHolidays = ['2018/01/01', '2018/03/21', '2018/03/30', '2018/04/02', '2018/04/27', '2018/05/01', '2018/06/16', '2018/08/09', '2018/09/24', '2018/12/16', '2018/12/17', '2018/12/25', '2018/12/26'];
        this.populateDatePicker();
    };
    // populating the current date picker
    FormItemBusinessTermLoan.prototype.populateDatePicker = function () {
        var _this = this;
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker('setStartDate', this._startDate);
            $(this.formDatePicker).change(function () {
                _this.formDatePicker.dispatchEvent(new Event('blur', {}));
            });
        }
    };
    FormItemBusinessTermLoan.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== 'Anytime') {
                if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
                    item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    FormItemBusinessTermLoan.prototype.bindEvents = function () {
        var _this = this;
        // Calender
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener('change', function (event) {
                _this.validateDate(event.target);
            });
        }
        // Step 1 Next Button
        if (this.step1Button) {
            this.step1Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step1");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.count += 1;
                    _this.iSstep1Completed = true;
                    _this.dtmVirtualPage('step 2 business details form');
                    _this.showStep(2);
                }
            });
        }
        // Step 2 Next Button
        if (this.step2Button) {
            this.step2Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step2");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                var _authorityToApply = _form.querySelector("input[name=permission-act]:checked");
                var _legallyEnterContracts = _form.querySelector("input[name=legal-contracts]:checked");
                var _debtReview = _form.querySelector("input[name=debt-review]:checked");
                var _declineReasons = _this.element.querySelector(".js-decline-reasons-list");
                var _covid19GovernmentLoan = _this.element.querySelector('input[name=covid-19-government-loan]');
                var businessRegNumberElem = _form.querySelector("input[name=business-reg-number]");
                var entityTypeElem = _form.querySelector("select[name=business-type]");
                var businessRegNumber = businessRegNumberElem.value;
                var entityType = entityTypeElem.value;
                var regNumYear = businessRegNumber.split('/')[0];
                var currentYear = new Date().getFullYear();
                if (Number(regNumYear) > currentYear) {
                    _this.isRegYearValid = false;
                    $('.business-reg-number-group').append("<div class=\"regYear_error form__group--error_message\"><ul><li>Registration number cannot be in the future</li></ul></div>");
                    window.scrollTo(0, 0);
                }
                else {
                    _this.isRegYearValid = true;
                    $('.regYear_error').remove();
                }
                if (businessRegNumber !== "") {
                    switch (entityType) {
                        case 'CLOSE':
                            // Close Corporation - CLOSE - 23
                            if (businessRegNumber.split('/')[2] !== '23') {
                                _this.isRegMatchingEntity = false;
                                $('.business-reg-number-group').append("<div class=\"mismatch_error form__group--error_message\"><ul><li>Registration number does not match with the entity type</li></ul></div>");
                                window.scrollTo(0, 0);
                            }
                            else {
                                _this.isRegMatchingEntity = true;
                                $('.mismatch_error').remove();
                            }
                            break;
                        case 'PRIVATE':
                        case 'SMALLBUSINESSCORP':
                        case 'LLC':
                            // Private Company - PRIVATE - 07
                            // Small Business Corporation - SMALLBUSINESSCORP - 07
                            // Limited Liability - LLC - 07
                            if (businessRegNumber.split('/')[2] !== '07') {
                                _this.isRegMatchingEntity = false;
                                $('.business-reg-number-group').append("<div class=\"mismatch_error form__group--error_message\"><ul><li>Registration number does not match with the entity type</li></ul></div>");
                                window.scrollTo(0, 0);
                            }
                            else {
                                _this.isRegMatchingEntity = true;
                                $('.mismatch_error').remove();
                            }
                            break;
                        case 'SOLE':
                            // Sole proprietor - SOLE - Must be SA id number, coverd by validation
                            _this.isRegMatchingEntity = true;
                            $('.mismatch_error').remove();
                            break;
                        default:
                            break;
                    }
                }
                else {
                    _this.isRegMatchingEntity = true;
                    $('.mismatch_error').remove();
                }
                _this.map.clear();
                _this.dataChecks = true;
                if (_this.isRegMatchingEntity && _this.isRegYearValid) {
                    if (valid.length === 0) {
                        if (_authorityToApply && _authorityToApply.value === 'NO') {
                            _this.dataChecks = false;
                            _this.map.set('Authority', 'Permission to act on behalf of the entity');
                        }
                        if (_legallyEnterContracts && _legallyEnterContracts.value === 'NO') {
                            _this.dataChecks = false;
                            _this.map.set('Legal', 'Legally enter into contracts');
                        }
                        if (_debtReview && _debtReview.value === 'YES') {
                            _this.dataChecks = false;
                            _this.map.set('DebtReview', 'Debt review');
                        }
                        if (_covid19GovernmentLoan && $('input[name="covid-19-government-loan"]:checked').val() === 'YES') {
                            _this.dataChecks = false;
                            _this.map.set('Covid19GovernmentLoan', 'Covid-19 Government Loan');
                        }
                        _declineReasons.innerHTML = '';
                        _this.map.forEach(function (value, key) {
                            var li = document.createElement('li');
                            li.innerHTML = value;
                            _declineReasons.appendChild(li);
                        });
                        if (!_this.dataChecks) {
                            _this.showDisplayView("decline");
                            window.scrollTo(0, 0);
                        }
                        else {
                            _this.count += 1;
                            if (!_this.iSstep2Completed && !dataLayer.formisSubmitted) {
                                _this.analyticsService.dtmFormComplete("complete", "", true);
                            }
                            _this.iSstep2Completed = true;
                            _this.dtmVirtualPage('step 3 loan details form');
                            _this.showStep(3);
                        }
                    }
                }
            });
        }
        // Step 3 Submit Button Click
        // Show modal on clicking Submit button
        if (this.buttonSubmit) {
            // Confirm button: log the loan amount and hide modal
            document.getElementById('confirmLoan').addEventListener('click', function () {
                // Hide the modal
                document.getElementById('loanConfirmModal').style.setProperty('display', 'none', 'important');
                _this.submitForm(_this.form);
                window.scrollTo(0, 0);
            });
            // Edit Amount button: hide modal to allow editing
            document.getElementById('editAmount').addEventListener('click', function () {
                document.getElementById('loanConfirmModal').style.setProperty('display', 'none', 'important');
            });
            // Close modal when clicking on the close icon
            document.getElementById('closeModal').addEventListener('click', function () {
                document.getElementById('loanConfirmModal').style.setProperty('display', 'none', 'important');
            });
            // Close modal when clicking outside the modal content
            window.addEventListener('click', function () {
                var modal = document.getElementById('loanConfirmModal');
                if (event.target == modal) {
                    modal.style.setProperty('display', 'none', 'important');
                }
            });
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step3");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var loanAmount = document.querySelector('input[name="loan-amount"]').value;
                if (_this.validateLoanAmount(loanAmount)) {
                    var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                    if (valid.length === 0) {
                        // Get the loan amount input value
                        document.getElementById('loanAmountValue').innerHTML = "R " + Number(loanAmount);
                        // Display the modal
                        document.getElementById('loanConfirmModal').style.setProperty('display', 'block', 'important');
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }
                else {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        // Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) { return item.addEventListener('click', function (event) {
                _this.showPreviousStep(event);
            }); });
        }
        if (this.businessType) {
            this.businessType.addEventListener("change", function (e) {
                _this.element.querySelector('.business-industry-label').classList.remove('mb-4');
                if (e.target.value.toUpperCase() === 'SOLE') {
                    _this.element.querySelector('input[name=entity-identity-number]').parentElement.parentElement.classList.remove('hidden');
                    _this.element.querySelector('input[name=entity-identity-number]').classList.add('form__input--required');
                    _this.element.querySelector('input[name=business-reg-number]').parentElement.parentElement.classList.add('hidden');
                    _this.element.querySelector('input[name=business-reg-number]').classList.remove('form__input--required');
                }
                else {
                    _this.element.querySelector('input[name=entity-identity-number]').parentElement.parentElement.classList.add('hidden');
                    _this.element.querySelector('input[name=entity-identity-number]').classList.remove('form__input--required');
                    _this.element.querySelector('input[name=business-reg-number]').parentElement.parentElement.classList.remove('hidden');
                    _this.element.querySelector('input[name=business-reg-number]').classList.add('form__input--required');
                }
            });
        }
        this.element.querySelector('input[name=business-reg-number]').addEventListener('input', function (e) {
            var value = e.target.value;
            // Remove all non-numeric characters
            value = value.replace(/[^0-9]/g, '');
            // Apply the formatting
            if (value.length > 10) {
                value = value.slice(0, 4) + '/' + value.slice(4, 10) + '/' + value.slice(10, 12);
            }
            else if (value.length > 4) {
                value = value.slice(0, 4) + '/' + value.slice(4);
            }
            e.target.value = value;
        });
        this.element.querySelector('input[name=business-reg-number]').addEventListener('focusout', function (e) {
            var _form = document.querySelector(".step2");
            var businessRegNumberElem = _form.querySelector("input[name=business-reg-number]");
            var entityTypeElem = _form.querySelector("select[name=business-type]");
            var businessRegNumber = businessRegNumberElem.value;
            var entityType = entityTypeElem.value;
            var regNumYear = businessRegNumber.split('/')[0];
            var currentYear = new Date().getFullYear();
            var businessRegNumberGroup = document.querySelector('.business-reg-number-group');
            var regYearErrorElem = document.querySelector('.regYear_error');
            var mismatchErrorElem = document.querySelector('.mismatch_error');
            if (Number(regNumYear) > currentYear) {
                regYearValid = false;
                if (!regYearErrorElem) {
                    var errorDiv = document.createElement('div');
                    errorDiv.classList.add('regYear_error');
                    errorDiv.innerHTML = '<ul><li>Registration number cannot be in the future</li></ul>';
                    businessRegNumberGroup.appendChild(errorDiv);
                    window.scrollTo(0, 0);
                }
            }
            else {
                regYearValid = true;
                $('.regYear_error').remove();
            }
            if (businessRegNumber !== "") {
                switch (entityType) {
                    case 'CLOSE':
                        // Close Corporation - CLOSE - 23
                        if (businessRegNumber.split('/')[2] !== '23') {
                            regTypeValid = false;
                            if (!mismatchErrorElem) {
                                var errorDiv = document.createElement('div');
                                errorDiv.classList.add('mismatch_error');
                                errorDiv.innerHTML = '<ul><li>Registration number does not match with the entity type</li></ul>';
                                businessRegNumberGroup.appendChild(errorDiv);
                                window.scrollTo(0, 0);
                            }
                        }
                        else {
                            regTypeValid = true;
                            $('.mismatch_error').remove();
                        }
                        break;
                    case 'PRIVATE':
                    case 'SMALLBUSINESSCORP':
                    case 'LLC':
                        // Private Company - PRIVATE - 07
                        // Small Business Corporation - SMALLBUSINESSCORP - 07
                        // Limited Liability - LLC - 07
                        if (businessRegNumber.split('/')[2] !== '07') {
                            regTypeValid = false;
                            if (!mismatchErrorElem) {
                                var errorDiv = document.createElement('div');
                                errorDiv.classList.add('mismatch_error');
                                errorDiv.innerHTML = '<ul><li>Registration number does not match with the entity type</li></ul>';
                                businessRegNumberGroup.appendChild(errorDiv);
                                window.scrollTo(0, 0);
                            }
                        }
                        else {
                            regTypeValid = true;
                            $('.mismatch_error').remove();
                        }
                        break;
                    case 'SOLE':
                        // Sole proprietor - SOLE - Must be SA id number, covered by validation
                        regTypeValid = true;
                        $('.mismatch_error').remove();
                        break;
                    default:
                        break;
                }
            }
            else {
                regTypeValid = true;
                $('.mismatch_error').remove();
            }
        });
        this.element.querySelector('input[name="loan-amount"]').addEventListener('blur', function (e) {
            var rawValue = e.target.value;
            _this.validateLoanAmount(rawValue);
        });
        this.modifiersRadiosToggle.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            _this.sbcustomer = element.value;
            _this.toggleModifiers(event, '.js-sb-customer-acc-no');
        }); });
        this.relPubOfficialRadiosToggle.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            _this.sbcustomer = element.value;
            _this.toggleModifiersPubOfficial(event, '.js-sb-relation-public-official');
        }); });
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm("done"); });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm("close"); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
            _this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute('hidden');
            _this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsShowBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute('hidden');
            _this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailShowBtn.removeAttribute('hidden');
        });
        this.relPartiesShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.relPartiesContent.removeAttribute('hidden');
            _this.relPartiesShowBtn.setAttribute('hidden', 'true');
            _this.relPartiesHideBtn.removeAttribute('hidden');
        });
        this.relPartiesHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.relPartiesContent.setAttribute('hidden', 'true');
            _this.relPartiesHideBtn.setAttribute('hidden', 'true');
            _this.relPartiesShowBtn.removeAttribute('hidden');
        });
    };
    FormItemBusinessTermLoan.prototype.validateLoanAmount = function (rawValue) {
        var amount = parseFloat(rawValue);
        if (isNaN(amount)) {
            this.showError("Please enter a valid number.");
            return false;
        }
        else if (amount < 10000) {
            this.showError("Minimum amount is R10 000.");
            return false;
        }
        else if (amount > 500000) {
            this.showError("Maximum amount is R500 000.");
            return false;
        }
        else {
            this.clearError();
            return true;
        }
    };
    FormItemBusinessTermLoan.prototype.showError = function (message) {
        setTimeout(function () {
            document.getElementById("loan-amount").classList.add("form__group--error");
        }, 200);
        var input = document.querySelector('input[name="loan-amount"]');
        // Remove existing error if any
        var existingError = input.nextElementSibling;
        if (existingError && existingError.classList.contains('form__group--error_message')) {
            existingError.remove();
        }
        // Create error element
        var errorDiv = document.createElement('div');
        errorDiv.className = 'form__group--error_message';
        errorDiv.innerHTML = "<ul><li>" + message + "</li></ul>";
        // Insert after the input
        setTimeout(function () {
            document.getElementById("loan-amount").classList.add("form__group--error");
            input.insertAdjacentElement('afterend', errorDiv);
        }, 200);
    };
    FormItemBusinessTermLoan.prototype.clearError = function () {
        var input = document.querySelector('input[name="loan-amount"]');
        var existingError = input.nextElementSibling;
        var loanField = document.getElementById("loan-amount");
        setTimeout(function () {
            loanField.classList.remove('form__group--error');
        }, 200);
        if (existingError && existingError.classList.contains('form__group--error_message')) {
            existingError.remove();
        }
    };
    FormItemBusinessTermLoan.prototype.ValidatePublicOfficialFields = function (value) {
        var _relpublicOfficialName = this.form.querySelector("input[name=name-rel-pub-official]");
        var _relpublicOfficialSurname = this.form.querySelector("input[name=surname-rel-pub-official]");
        var _relpublicOfficialNature = this.form.querySelector("input[name=nature-of-relation]");
        if (value) {
            _relpublicOfficialName.classList.add('form__input--required');
            _relpublicOfficialSurname.classList.add('form__input--required');
            _relpublicOfficialNature.classList.add('form__input--required');
        }
        else {
            _relpublicOfficialName.classList.remove('form__input--required');
            _relpublicOfficialSurname.classList.remove('form__input--required');
            _relpublicOfficialNature.classList.remove('form__input--required');
        }
    };
    FormItemBusinessTermLoan.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
        }
        this.form.reset();
        window.location.href = '/southafrica/business/products-and-services/borrow-for-your-needs/business-loans/business-term-loan';
    };
    FormItemBusinessTermLoan.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (this.bulletContainer) {
            var _bullets = Array.from(this.bulletContainer.querySelectorAll('.form-container-wizard__bullets-container--bullet'));
            _bullets.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute('data-step'));
                if (displayStep <= showStep) {
                    pItem.classList.add('form-container-wizard__bullets-container--bullet--active');
                }
                else {
                    pItem.classList.remove('form-container-wizard__bullets-container--bullet--active');
                }
            });
            var _bulletLines = Array.from(this.bulletContainer.querySelectorAll('.form-item-business-term-loan__form-container-wizard__bullets-container--bullet--link'));
            _bulletLines.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute('data-step'));
                if (showStep > displayStep) {
                    pItem.classList.add('form-item-business-term-loan__form-container-wizard__bullets-container--bullet--link--active');
                }
                else {
                    pItem.classList.remove('form-item-business-term-loan__form-container-wizard__bullets-container--bullet--link--active');
                }
            });
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll('.form-container-wizard__steps--step'));
        var _heading = '';
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute('data-step'));
            if (_step === showStep) {
                _heading = pStep.getAttribute('data-heading');
                pStep.classList.remove('form-container-wizard__steps--hidden');
            }
            else {
                pStep.classList.add('form-container-wizard__steps--hidden');
            }
        });
        var _h3Heading = this.customHeading.querySelector('h3');
        if (_heading != null) {
            _h3Heading.innerHTML = _heading;
        }
        var _stepno = this.stepNo.querySelector('h6');
        if (_stepno != null) {
            _stepno.innerHTML = 'STEP ' + showStep + ' OF 3';
        }
        window.scrollTo(0, 0);
    };
    FormItemBusinessTermLoan.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest('[data-step]');
        var _nextStep = _currentStep.getAttribute('data-step');
        this.showStep(parseFloat(_nextStep));
        window.scrollTo(0, 0);
    };
    FormItemBusinessTermLoan.prototype.toTitleCase = function (str) {
        return str.toLowerCase().replace(/\b\w/g, function (char) { return char.toUpperCase(); });
    };
    FormItemBusinessTermLoan.prototype.submitForm = function (form) {
        var _this = this;
        var _firstName = form.querySelector("input[name=first-name]");
        var _surname = form.querySelector("input[name=surname]");
        var _emailAddress = form.querySelector("input[name=email-address]");
        var _phoneNumber = form.querySelector("input[name=contact-number]");
        var _identificationNo = form.querySelector("input[name=identity-number]");
        var _entityType = form.querySelector("select[name=business-type]");
        var _numberOfYearsTrading = form.querySelector("input[name=business-trade-years]");
        var _businessName = form.querySelector("input[name=business-name]");
        var _numberOfDirectors = form.querySelector("select[name=business-directors]");
        var _businessEmailAddress = form.querySelector("input[name=business-email-address]");
        var _businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var _businessId = form.querySelector("input[name=entity-identity-number]");
        var _businessIndustry = form.querySelector("select[name=business-industry]");
        var _businessRegion = form.querySelector("select[name=business-region]");
        var _businessNature = form.querySelector("select[name=business-nature]");
        var _authorityToApply = form.querySelector("input[name=permission-act]");
        var _obtainStatementsElectronically = form.querySelector("input[name=obtain-statements-electronically]");
        var _legallyEnterContracts = form.querySelector("input[name=legal-contracts]");
        var _debtReview = form.querySelector("input[name=debt-review]");
        var _loanAmount = form.querySelector("input[name=loan-amount]");
        var _purposeOfLoan = form.querySelector("select[name=loan-purpose]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        this.companyRegistrationOrId = this.businessType.value === 'SOLE' ? _businessId.value : _businessRegNumber.value.replaceAll('/', '');
        var _businessIncome = this.getDataConsentValue(form, 'bus-income');
        var _businessExpense = this.getDataConsentValue(form, 'bus-expenses');
        var _businessExpensesAmount = form.querySelector('input[name=business-expenses]');
        var _businessIncomeAmount = form.querySelector('input[name=business-income]');
        var _channel = 'COZA';
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _dateTime = "anytime";
        if (_date && _time) {
            _dateTime = _date.value + " " + _time.value;
        }
        //new fields
        var _relationtocompany = form.querySelector("select[name=business-relation]");
        var _relPublicOfficial = form.querySelector("input[name=rel-public-official]");
        var _publicOfficial = form.querySelector("input[name=public-official]");
        var _namerelpubofficial = form.querySelector("input[name=name-rel-pub-official]");
        var _surnamerelpubofficial = form.querySelector("input[name=surname-rel-pub-official]");
        var _natureofrelation = form.querySelector("input[name=nature-of-relation]");
        var _publicOfficialRelation = ((_relPublicOfficial ? (_relPublicOfficial.checked ? "YES" : "NO") : "NO"));
        var _postData = {
            'cusIsRedirected': 'NO',
            'productRedirectedFrom': '',
            'cusBank': '',
            'Applicant_Firstname': this.toTitleCase(_firstName ? _firstName.value : ''),
            'Applicant_Surname': this.toTitleCase(_surname ? _surname.value : ''),
            'Applicant_IDNumber': (_identificationNo ? _identificationNo.value : ''),
            'Applicant_Email': (_emailAddress ? _emailAddress.value : ''),
            'ContactNumber': (_phoneNumber ? _phoneNumber.value : ''),
            'PersonalInfo_UsageConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'Identity_FraudCheck_BusinessConsent': '',
            'CreditBureau_Check_BusinessConsent': '',
            'Identity_FraudCheck_CustomerConsent': '',
            'CreditBureau_Check_CustomerConsent': '',
            'IsBusiness_UnderRescue': ((_debtReview ? (_debtReview.checked ? "yes" : "no") : "no")),
            'IsBusiness_Wound_Dissovled_liquid': ((_debtReview ? (_debtReview.checked ? "YES" : "NO") : "NO")),
            'IsBusiness_Unable_toPay': ((_debtReview ? (_debtReview.checked ? "YES" : "NO") : "NO")),
            'Business_EntityType': (_entityType ? _entityType.value : ''),
            'Business_Trading_Years': (_numberOfYearsTrading ? _numberOfYearsTrading.value : ''),
            'Business_Name': (_businessName ? _businessName.value : ''),
            'Total_Directors': (_numberOfDirectors ? _numberOfDirectors.value : ''),
            'Business_Email': (_businessEmailAddress ? _businessEmailAddress.value : ''),
            'Business_RegNumber': this.companyRegistrationOrId,
            'INDUSTRY': (_businessIndustry ? _businessIndustry.value : ''),
            'Business_Description': '',
            'Customer_HasLegalDisability': (_legallyEnterContracts ? _legallyEnterContracts.value.toLowerCase() : ''),
            'Business_region': (_businessRegion ? _businessRegion.value : ''),
            'Business_NatureOf': (_businessNature ? _businessNature.value : ''),
            'Authority_ToApply': ((_authorityToApply ? (_authorityToApply.checked ? "yes" : "no") : "no")),
            'Obtain_Statements_Electronically': ((_obtainStatementsElectronically ? (_obtainStatementsElectronically.checked ? "yes" : "no") : "no")),
            'Loan_Amount': (_loanAmount ? Number(_loanAmount.value) : ''),
            'Purpose_Of_Loan': (_purposeOfLoan ? "" + _purposeOfLoan.value : ''),
            'IsBusiness_UnderDebtReview': ((_debtReview ? (_debtReview.checked ? "YES" : "NO") : "NO")),
            'Best_Call_Time': _dateTime,
            'Channel': _channel,
            'formLocation': this.formLocationService.getLocation(),
            'Income_Freq': _businessIncome === "YES" ? 'MONTHLY' : 'ANNUAL',
            'Business_Income': (_businessIncomeAmount ? Number(_businessIncomeAmount.value) : ''),
            'Expenses_Freq': _businessExpense === "YES" ? 'MONTHLY' : 'ANNUAL',
            'Business_Expenses': (_businessExpensesAmount ? Number(_businessExpensesAmount.value) : ''),
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.getDataConsentValue(form, 'data-sharing-email'),
            'C19_Loan': this.getDataConsentValue(form, 'covid-19-government-loan').toLowerCase(),
            'dataSharingSms': this.getDataConsentValue(form, 'data-sharing-sms'),
            'dataSharingInApp': 'YES',
            'Up_Sell': '',
            'Relation_To_Company': (_relationtocompany ? _relationtocompany.value : ''),
            'Relation_To_public_Official': ((_relPublicOfficial ? (_relPublicOfficial.checked ? "YES" : "NO") : "NO")),
            'Public_Official': ((_publicOfficial ? (_publicOfficial.checked ? "YES" : "NO") : "NO")),
            'Name_relation_Party': _publicOfficialRelation === "NO" ? '' : (_namerelpubofficial ? _namerelpubofficial.value : ''),
            'Surname_Relation_Party': _publicOfficialRelation === "NO" ? '' : (_surnamerelpubofficial ? _surnamerelpubofficial.value : ''),
            'Nature_Of_Relation': _publicOfficialRelation === "NO" ? '' : (_natureofrelation ? _natureofrelation.value : '')
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/sites/services/NTBBTLForm.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var ntbBTLPayloadJson = 'ntbbtlPayload=' + JSON.stringify(_postData);
        // service
        this.formsService.postForm(url, ntbBTLPayloadJson, _config).then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmFormComplete("complete", '', false);
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.dtmVirtualPage('step 4 success form');
                if (!_this.iSstep3Completed && !dataLayer.formisSubmitted) {
                    _this.analyticsService.dtmFormComplete("complete", pResponse.code, true);
                }
                _this.iSstep3Completed = true;
                _this.analyticsService.completeDtmApplication();
                _this.showDisplayView("success");
                _this.dtmVirtualPage("thank you");
                _this.analyticsService.dtmFormComplete("complete", pResponse.data.applicationId, true);
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessTermLoan.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemBusinessTermLoan.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayDecline.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "decline":
                this.displayDecline.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    FormItemBusinessTermLoan.prototype.dtmVirtualPage = function (pPageNameNew) {
        var taggingValue = pPageNameNew === 'thank you' ?
            'business:products and services:borrow for your needs:business loans:business term loans success thank you' : "business:products and services:borrow for your needs:business loans:business term loan";
        dataLayer.pageName = taggingValue;
        if (typeof _satellite === 'object') {
            _satellite.track('globalVirtualPageView');
        }
    };
    FormItemBusinessTermLoan.prototype.updatePageName = function (pageName) {
        dataLayer.pageName = "business:products and services:borrow for your needs:business loans:business term loan";
    };
    FormItemBusinessTermLoan.prototype.updateFormName = function () {
        this.analyticsService.dtmFormNameUpdate('business:products and services:borrow for your needs:business loans:business term loan');
        this.analyticsService.dtmAllowFormRefresh();
    };
    FormItemBusinessTermLoan.prototype.toggleModifiers = function (event, selector) {
        var targetModifier = this.element.querySelector(selector);
        var element = event.target;
        if (targetModifier) {
            if (element.value === 'YES') {
                targetModifier.classList.remove('form-item-business-term-loan__hidden');
                targetModifier.classList.add('form-item-business-term-loan__active');
            }
            else {
                targetModifier.classList.remove('form-item-business-term-loan__active');
                targetModifier.classList.add('form-item-business-term-loan__hidden');
            }
        }
    };
    FormItemBusinessTermLoan.prototype.toggleModifiersPubOfficial = function (event, selector) {
        var targetModifier = this.element.querySelector(selector);
        var element = event.target;
        if (targetModifier) {
            if (element.value === 'YES') {
                this.ValidatePublicOfficialFields(true);
                targetModifier.classList.remove('form-item-business-term-loan__hidden');
                targetModifier.classList.add('form-item-business-term-loan__active');
            }
            else {
                this.ValidatePublicOfficialFields(false);
                targetModifier.classList.remove('form-item-business-term-loan__active');
                targetModifier.classList.add('form-item-business-term-loan__hidden');
            }
        }
    };
    return FormItemBusinessTermLoan;
}(Base));
export { FormItemBusinessTermLoan };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-business-term-loan/form-item-business-term-loan.component.ts
// module id = 1017
// module chunks = 0